import { render, staticRenderFns } from "./ContactFloat.vue?vue&type=template&id=74c77f71&scoped=true"
import script from "./ContactFloat.vue?vue&type=script&lang=js"
export * from "./ContactFloat.vue?vue&type=script&lang=js"
import style0 from "./ContactFloat.vue?vue&type=style&index=0&id=74c77f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c77f71",
  null
  
)

export default component.exports